import React, { useState} from "react";

import { db,auth } from "../../firebase";
import { doc, Timestamp,updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Industrynav from "./Industrynav";
import "./industry.css";


const Industryform = () => {

  const [data, setData] = useState({cname: "",cemail: "",ccontact: "",address:"",description:"",error: null,loading: false,
});
  const navigate = useNavigate();

  const {cname,cemail,address,ccontact,description,error,loading,} = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!cname || !address || !description || !ccontact || !cemail
    ) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
     
        await updateDoc(doc(db,'Industry',auth.currentUser.uid), {
          cname,
          cemail,
          address,
          description,
          ccontact,
          createdAt: Timestamp.fromDate(new Date()),
          isOnline: true,
        });
      // })
      setData({cname: "",cemail: "",ccontact: "",address:"",description:"",error: null,loading: false,});
      navigate("/industryhome");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };
    

  return(
    <>
      <Industrynav/>
      <div id="wrapper">
        <div className="form_div">
          <p className="form_label">COMPANY DETAILS</p>
          <form method="post" action="#" onSubmit={handleSubmit}>
            <p>   <input
              type="text"
              name="cname"
              value={cname}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Company Name..."
              required
            /></p>
            <p>
            <input
              type="email"
              name="cemail"
              value={cemail}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Company Email..."
              required
            />
            </p>
            <p> <input
              type="text"
              name="address"
              value={address}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Company Address..."
              v-model="signup.user"
              required
            /></p>
            <p>
            <input
              type="text"
              name="ccontact"
              value={ccontact}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Company Contact Details..."
              v-model="signup.user"
              required
            />
            </p>
            <p> <textarea
              type="text"
              name="description"
              value={description}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Company Description..."
              v-model="signup.user"
              required
            /></p>
            
            {error ? <p className="error">{error}</p> : null}
            {/* <p><input type="submit" defaultValue="LOGIN" /></p> */}
            <button
              type="submit"
              className="btn w-75 btn-submit pr"
              required
              disabled={loading}
            >
              {loading ? "Submitting in..." : "Submit"}
            </button>
          </form>


        </div>
        <br />
        <br />
        <br />
      </div>
    
    </>
  );
};

export default Industryform;
